// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#dropdown[data-v-2806f719]{position:relative;display:inline-block}.drop-content[data-v-2806f719]{display:none;position:absolute;background-color:#f9f9f9;min-width:160px;box-shadow:0 8px 16px 0 rgba(0,0,0,.2);padding:12px 16px;z-index:1}#dropdown:hover .drop-content[data-v-2806f719]{display:block}#drop-btn[data-v-2806f719]{padding:5px;background-color:#f5f5f5;color:#20b2aa;border:1px solid #20b2aa;border-radius:10px}", ""]);
// Exports
module.exports = exports;
